import type { AssistantProcessingResponse } from "@/types/assistant";

export function getAssistantResourceStateKey(platform: string) {
  return ["assistant-data", "state", platform];
}

export function useAssistantResourceStateRequest(
  platformId: string,
  enabled: globalThis.Ref
) {
  const query = useQuery({
    queryKey: getAssistantResourceStateKey(platformId),
    queryFn: async () => {
      const response = await useGetRequest<AssistantProcessingResponse>("/account/data", {
        params: {
          itemId: platformId,
          getSummary: true,
        },
      });
      return response?.data || null;
    },
    staleTime: 5 * MINUTE,
    enabled,
    retry: 1,
  });
  return query;
}
